export const TOTAL_BUCKET_SHARE: number = 100;
export const WEBSITE_BUCKET_DESC_MIN_LENGTH: number = 10;
export const WEBSITE_DESC_MIN_LENGTH_ERROR_MESSAGE: string = `Description should be at least ${WEBSITE_BUCKET_DESC_MIN_LENGTH} characters long`;

export enum EWebsiteUpdateDashBoardActions {
	edit = 'edit',
	add = 'add',
	clone = 'clone',
	deploy = 'deploy'
}
